'use client';

import { useProgressContext } from '@/app/components/Provider';

export const ProgressBar = () => {
  const { percent } = useProgressContext();

  return (
    <div className="progress-content">
      <div
        style={{ width: `${percent}%` }}
        className="progress"
        data-testid="progress"
      />
    </div>
  );
};
